import { cn } from '@/lib/utils';
import { mapStatus } from '@/lib/clientStatus';
import { StatusBadge } from '@/components/ui/StatusBadge';
import type { Account } from '@/models/account/types';
import type { AccountSearch } from '@/models/clients/types';

type Props = {
  account: Account | null;
  accountSearch: AccountSearch | undefined;
  clientBalance: number;
  currency: string;
};

export function ClientSummary({ account, accountSearch, clientBalance, currency }: Props) {
  const name = accountSearch?.account_name ?? account?.account_name ?? '?';
  const statusName = accountSearch?.status_name ?? account?.status_name ?? '';
  const accountType = accountSearch?.account_type_name ?? '—';
  const balance = account?.balance ?? clientBalance;

  const apiStatus = mapStatus(statusName);
  const effectiveStatus = apiStatus === 'debtor' && balance >= 0 ? 'active' : apiStatus;
  const statusLabel = effectiveStatus !== apiStatus ? undefined : statusName || undefined;

  return (
    <div className='border border-border/30 rounded-2xl p-5 bg-card'>
      <div className='flex items-start gap-4'>
        <div className='w-14 h-14 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0'>
          <span className='text-primary text-xl font-semibold'>{name[0]}</span>
        </div>
        <div className='flex-1 min-w-0'>
          <div className='flex items-center gap-3 flex-wrap mb-1'>
            <h2 className='text-xl font-medium text-foreground'>{name}</h2>
            <StatusBadge status={effectiveStatus} label={statusLabel} size='md' />
          </div>
          <p className='text-sm text-muted-foreground mb-4'>{accountType}</p>
          <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
            {[
              { label: 'Логин', value: accountSearch?.login ?? account?.login ?? '—', mono: true },
              { label: 'Договор', value: account?.dog_num ?? '—', mono: true },
              { label: 'Услуги', value: accountSearch?.services_status ?? '—' },
              {
                label: 'Баланс',
                value:
                  `${balance > 0 ? '+' : ''}${balance.toLocaleString('ru-RU')} ${currency}`.trimEnd(),
                colored:
                  balance < 0
                    ? 'text-red-400'
                    : balance > 0
                      ? 'text-green-400'
                      : 'text-muted-foreground',
              },
            ].map((item) => (
              <div key={item.label}>
                <p className='text-xs text-muted-foreground mb-0.5'>{item.label}</p>
                <p
                  className={cn(
                    'text-sm font-medium',
                    item.mono && 'font-mono',
                    item.colored ?? 'text-foreground'
                  )}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
